import type { Ref, SVGProps } from 'react';
import React, { forwardRef } from 'react';

export const LBGoogleIcon = forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<'svg'>
>((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    ref={ref}
    fill='none'
    height={18}
    width={18}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#a)'>
      <path
        d='M17.99 9.168c0-.737-.062-1.275-.194-1.833H9.178v3.328h5.058c-.102.827-.653 2.073-1.876 2.91l-.018.112 2.725 2.062.189.019c1.733-1.565 2.732-3.867 2.732-6.598Z'
        fill='#4285F4'
      />
      <path
        d='M9.18 17.938c2.477 0 4.557-.797 6.077-2.172l-2.896-2.193c-.775.528-1.816.897-3.182.897a5.513 5.513 0 0 1-5.22-3.727l-.108.009-2.833 2.143-.037.1c1.51 2.93 4.609 4.943 8.198 4.943Z'
        fill='#34A853'
      />
      <path
        d='M3.958 10.743a5.41 5.41 0 0 1-.306-1.774c0-.618.113-1.216.296-1.774l-.005-.119L1.075 4.9l-.094.044a8.812 8.812 0 0 0-.979 4.026c0 1.445.357 2.81.979 4.026l2.977-2.252Z'
        fill='#FBBC05'
      />
      <path
        d='M9.18 3.468c1.722 0 2.885.728 3.548 1.335l2.59-2.471C13.727.887 11.657 0 9.179 0 5.59 0 2.49 2.013.981 4.943l2.967 2.252A5.536 5.536 0 0 1 9.18 3.468Z'
        fill='#EB4335'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path d='M0 0h18v18H0z' fill='#fff' />
      </clipPath>
    </defs>
  </svg>
));
